import { getRouteApi } from '@tanstack/react-router';
import { useUrlSyncedSearch } from '@/hooks/useUrlSyncedSearch';

const route = getRouteApi('/_auth/market-promotion/projects');

export function useMarketProjectSearch() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const nameSearch = useUrlSyncedSearch({
    appliedText: search.search,
    onApply: (text) => {
      void navigate({
        search: (previous) => ({ ...previous, search: text }),
        replace: true,
      });
    },
  });

  return { ...nameSearch, search };
}
